import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=ffdf0856&lang=scss&setup=true"

const __exports__ = script;

export default __exports__